export default "__VITE_ASSET__CHjzzpz7__"